export const CHART_TOOLTIP_CONTENT_STYLE = {
    backgroundColor: '#fff',
    border: '1px solid #e0e0e0',
    borderRadius: '5px',
    fontSize: '12px',
    titleColor: '#333',
    bodyColor: '#333',
};
